if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.primaryQuantity = this.productInfo?.querySelector('.product-form__quantity .quantity__input');
        this.primaryButton = this.productInfo?.querySelector('.product-form__submit');
        this.stickyQuantity = this.querySelector('.sticky-atc__quantity-input');
        this.stickyButton = this.querySelector('.sticky-atc__submit');

        if (!this.primaryButton || !this.stickyButton) return;

        this.onPrimaryQuantityChange = (event) => this.syncQuantity(event.currentTarget, this.stickyQuantity);
        this.onStickyQuantityChange = (event) => this.syncQuantity(event.currentTarget, this.primaryQuantity);
        this.primaryQuantity?.addEventListener('input', this.onPrimaryQuantityChange);
        this.primaryQuantity?.addEventListener('change', this.onPrimaryQuantityChange);
        this.stickyQuantity?.addEventListener('input', this.onStickyQuantityChange);
        this.stickyQuantity?.addEventListener('change', this.onStickyQuantityChange);

        this.stickyButton.addEventListener('click', () => {
          if (!this.primaryButton.disabled && this.primaryButton.getAttribute('aria-disabled') !== 'true') {
            this.primaryButton.click();
          }
        });

        this.syncQuantityRules();
        this.syncQuantity(this.primaryQuantity, this.stickyQuantity, false);
        this.syncButtonState();

        if (this.primaryQuantity) {
          this.quantityObserver = new MutationObserver(() => {
            this.syncQuantityRules();
            this.syncQuantity(this.primaryQuantity, this.stickyQuantity, false);
          });
          this.quantityObserver.observe(this.primaryQuantity, { attributes: true });
        }

        this.buttonObserver = new MutationObserver(() => this.syncButtonState());
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(([entry]) => {
            this.toggleAttribute('data-visible', !entry.isIntersecting);
          });
          this.visibilityObserver.observe(this.primaryButton);
        } else {
          this.updateVisibility = () => {
            const rect = this.primaryButton.getBoundingClientRect();
            this.toggleAttribute('data-visible', rect.bottom <= 0 || rect.top >= window.innerHeight);
          };
          window.addEventListener('scroll', this.updateVisibility, { passive: true });
          window.addEventListener('resize', this.updateVisibility);
          this.updateVisibility();
        }
      }

      disconnectedCallback() {
        this.primaryQuantity?.removeEventListener('input', this.onPrimaryQuantityChange);
        this.primaryQuantity?.removeEventListener('change', this.onPrimaryQuantityChange);
        this.stickyQuantity?.removeEventListener('input', this.onStickyQuantityChange);
        this.stickyQuantity?.removeEventListener('change', this.onStickyQuantityChange);
        this.quantityObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (this.updateVisibility) {
          window.removeEventListener('scroll', this.updateVisibility);
          window.removeEventListener('resize', this.updateVisibility);
        }
      }

      syncQuantity(source, target, notify = true) {
        if (!source || !target || this.syncingQuantity) return;
        this.syncingQuantity = true;
        target.value = source.value;
        if (notify) {
          target.dispatchEvent(new Event('input', { bubbles: true }));
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.syncingQuantity = false;
      }

      syncQuantityRules() {
        if (!this.primaryQuantity || !this.stickyQuantity) return;
        ['min', 'max', 'step', 'data-min', 'data-max'].forEach((attribute) => {
          const value = this.primaryQuantity.getAttribute(attribute);
          if (value === null) this.stickyQuantity.removeAttribute(attribute);
          else this.stickyQuantity.setAttribute(attribute, value);
        });
        this.stickyQuantity.closest('quantity-input')?.validateQtyRules();
      }

      syncButtonState() {
        if (!this.primaryButton || !this.stickyButton) return;
        this.stickyButton.disabled = this.primaryButton.disabled;
        const primaryLabel = this.primaryButton.querySelector('span')?.textContent?.trim();
        const stickyLabel = this.stickyButton.querySelector('span');
        if (primaryLabel && stickyLabel) stickyLabel.textContent = primaryLabel;
        this.stickyButton.setAttribute(
          'aria-disabled',
          String(this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true')
        );
      }
    }
  );
}
